import React from "react";
import { windfarmTimeLabel } from "../../prettyDate";
import "./windfarm-time-note.css";

/**
 * One line under a windfarm's name saying which clock the page's times are on. Takes the
 * windfarm's time zone as windfarmTimeZone() gives it, and renders nothing while that is still
 * `undefined` (not looked up yet), so the line does not first claim UTC and then change.
 */
export default function WindfarmTimeNote({ timeZone, className = "" }) {
  if (timeZone === undefined) return null;

  return (
    <p className={`windfarm-time-note ${className}`.trim()}>
      {windfarmTimeLabel(timeZone).note}
    </p>
  );
}
